import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-37d8aeae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "animate modal"
}
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Short Creado", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Gestionar Mi Canal", -1))
const _hoisted_6 = { class: "animate form" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Redactar Short", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "new-question" }, "Volver a Gestionar Mi Canal", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Título del Short", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Debe ser conciso y no extenderse más allá de 60 caracteres", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Contenido del Short", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "</>", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { ref } from 'vue'
//import { useRoute } from 'vue-router'
import ChannelService from '@/services/ChannelService'
import { useAuth } from '@/store/useAuth'
import useWindowWidth from '@/composables/useWindowWidth'
import { useToast } from '@/store/useToast'
import { Toast } from '@/interfaces/ToastInterface';
import main from '@/data/main.js'



export default /*#__PURE__*/_defineComponent({
  __name: 'CodeBiteWrite',
  setup(__props) {

const toast = useToast()
const service = new ChannelService()
const store = useAuth()
const title = ref('')
const description = ref('')
const showFeedback = ref(false)
const { windowWidth } = useWindowWidth()
const descriptionBox = ref()

const hanldeDescription = () => {
    description.value = descriptionBox.value.getHTML()
}

const storeCodebite = async () => {
    if (!store.token) { return; }

    if(title.value.length < 3 || title.value.length > 255) {
        toast.showToast("La extensión del título no es válida.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }
    if(description.value.length < 10) {
        toast.showToast("La extensión de la descripción es demasiado corta.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return;
    }

    const response = await service.CreateCodeBite(store.token, title.value, description.value)

    if (response != true) {
        toast.showToast("Upps... Algo salió mal.", Toast.DANGER)
        setTimeout(function () { toast.hideToast() }, 4000);
        return
    }

    showFeedback.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_quill_editor = _resolveComponent("quill-editor")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (showFeedback.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              (_unref(windowWidth) >= 1000)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(main).CODE_BITE_WRITE,
                    style: {"width":"100%"}
                  }, null, 8, _hoisted_4))
                : _createCommentVNode("", true),
              _createVNode(_component_RouterLink, {
                to: { name: 'social-profile-edit' },
                style: {"text-decoration":"none"}
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _hoisted_8,
        _createVNode(_component_RouterLink, {
          to: { name: 'social-profile-edit' },
          style: {"text-decoration":"none"}
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          class: "input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((title).value = $event)),
          type: "text",
          max: "60",
          maxlength: "60",
          required: ""
        }, null, 512), [
          [_vModelText, title.value]
        ]),
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("p", null, [
          _createTextVNode("Usa la herramienta "),
          _hoisted_15,
          _createTextVNode(" para escribir código. Mejorará mucho su legibilidad. Puede contener la extensión que desees, pero lo ideal es que no sea demasiado extenso para mantener el espíritu de los Shorts. Si deseas publicar algo más extenso, prueba a escribir un "),
          _createVNode(_component_RouterLink, { to:  { name: 'new-codepost' }  }, {
            default: _withCtx(() => [
              _createTextVNode("nuevo Post")
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_quill_editor, {
          ref_key: "descriptionBox",
          ref: descriptionBox,
          theme: "snow",
          modelValue: description.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((description).value = $event)),
          toolbar: "full",
          "onUpdate:content": hanldeDescription
        }, null, 8, ["modelValue"]),
        _hoisted_16,
        _createElementVNode("button", {
          class: "new-question",
          onClick: storeCodebite
        }, [
          _createTextVNode("Crear Short "),
          _createVNode(_component_v_icon, {
            name: "io-send",
            style: {"margin-left":"10px"}
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})